import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CheckCircleOutlineIcon,
  ErrorOutlineIcon,
} from "../../../../common/MuiImports";
import { useTranslation } from "react-i18next";

interface UpdateCustomerModalProps {
  open: boolean;
  onClose: () => void;
  isError: boolean;
  errorMessage?: string;
}

const UpdateCustomerModal: React.FC<UpdateCustomerModalProps> = ({
  open,
  onClose,
  isError,
  errorMessage,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="update-customer-dialog-title"
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          width: { xs: "100%", md: "400px", padding: 10 },
        },
      }}
      data-test-id="update-customer-modal"
    >
      <DialogTitle
        id="update-customer-dialog-title"
        sx={{ textAlign: "center" }}
        data-test-id="update-customer-modal-title"
      >
        {" "}
        {isError ? (
          <ErrorOutlineIcon
            color="error"
            sx={{ fontSize: 48 }}
            data-test-id="update-customer-error-icon"
          />
        ) : (
          <CheckCircleOutlineIcon
            color="success"
            sx={{ fontSize: 48 }}
            data-test-id="update-customer-success-icon"
          />
        )}
      </DialogTitle>
      <DialogContent data-test-id="update-customer-modal-content">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
          data-test-id="update-customer-message-container"
        >
          <Typography
            variant="h5"
            sx={{ fontSize: 24 }}
            data-test-id="update-customer-modal-heading"
          >
            {isError
              ? t("updateCustomerModal.errorTitle")
              : t("updateCustomerModal.successTitle")}
          </Typography>
          <Typography data-test-id="update-customer-modal-message">
            {isError
              ? errorMessage || t("updateCustomerModal.errorMessageDefault")
              : t("updateCustomerModal.successMessage")}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions data-test-id="update-customer-modal-actions">
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          fullWidth
          data-test-id="update-customer-modal-done-button"
        >
          {t("updateCustomerModal.doneButton")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateCustomerModal;
